import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './PasswordInput.module.scss';
import cn from 'classnames';
import HiddenEyeIcon from '../AlertTemplate/icons/HiddenEyeIcon';
import EyeIcon from '../AlertTemplate/icons/EyeIcon';

const InputTypes = {
  PASSWORD: 'password',
  TEXT: 'text',
};

export function PasswordInput(props) {
  const { className = '', focus = true, ...inputProps } = props;
  const inputRef = useRef();
  const [isHidden, setIsHidden] = useState(true);

  const inputParams = {
    ...inputProps,
    value: props.value || '',
  };

  useEffect(() => {
    if (focus) {
      inputRef.current.focus();
    }
  }, [focus]);

  return (
    <div className={cn(styles.passwordContainer, className)}>
      <div>
        <input {...inputParams} type={isHidden ? InputTypes.PASSWORD : InputTypes.TEXT} ref={inputRef} />
        <span className={styles.eyeIcon} onClick={() => setIsHidden((prevState) => !prevState)}>
          {isHidden ? <EyeIcon /> : <HiddenEyeIcon />}
        </span>
      </div>
    </div>
  );
}

export default PasswordInput;

PasswordInput.propTypes = {
  className: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  focus: PropTypes.bool,
};
